module.exports = __webpack_public_path__ + "static/media/spoynt.a3e7ff2a.svg";